import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { Service } from '../../../models/service.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { ServiceService } from '../../../services/service/service.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css'],
  providers: []
})
export class ServiceComponent implements OnInit {

  public services: Service[] = [];
  public editData: Service;
  public showAddOrEdit = false;
  public newDataAvailable = false;
  public clientPagination = KontableComponent.ClientPagination;
  modalTitle = '';
  labels = {};
  flgDirectActiveList: SelectItem[] = [];

  constructor (
    private srvService: ServiceService,
    private translate: TranslateService) {
  }

  ngOnInit() {

    this.translate.get([
      'serviceList.add_title',
      'serviceList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['serviceList.add_title'];
      this.labels['edit_title'] = res['serviceList.edit_title'];
    });

    this.flgDirectActiveList = [
      {label: this.translate.instant('shoppingList.no'), value: "0"},
      {label: this.translate.instant('shoppingList.yes'), value: "1"},
      {label: this.translate.instant('cluster_ochannel.yesConfirm'), value: "2"}
    ]

    this.refresh();
  }

  refresh() {
    this.srvService.getAll().subscribe((services) => {
      this.services = services;
      this.newDataAvailable = true;

      let flag: SelectItem;
      this.services.forEach(service => {
        flag = this.flgDirectActiveList.find(flag => service.flg_direct_active == flag.value);
        if(flag) {
          service.flg_direct_active_description = flag.label;
        }
      })
      
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.editData = data;
    this.showAddOrEdit = true;
  }

  deleteService (record): void {
    this.srvService.delete(record).subscribe(() => {
      this.refresh ();
    });
  }

  closeDialog(event, table) {
    if (event === true) {
      this.showAddOrEdit = false;
    }
    setTimeout(() => {
      this.refresh();
      table.refresh();
    }, 300);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/service/service.component.ts